module.exports = __webpack_public_path__ + "static/4-a381fcffa26a7686a75b6ac351969dfa.png";